/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Заказчик
 */
export type OrderCreateCustomer = {
  /**
   * Тип заказчика
   */
  type: OrderCreateCustomer.type
  /**
   * Идентификатор заказчика (обязательное поле при type = Legal)
   */
  customerId?: string
}
export namespace OrderCreateCustomer {
  /**
   * Тип заказчика
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
